import { render, staticRenderFns } from "./SkillsList.vue?vue&type=template&id=2fbe5a6b&scoped=true&"
import script from "./SkillsList.vue?vue&type=script&lang=js&"
export * from "./SkillsList.vue?vue&type=script&lang=js&"
import style0 from "./SkillsList.vue?vue&type=style&index=0&id=2fbe5a6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe5a6b",
  null
  
)

export default component.exports